import { useMutation } from '@tanstack/react-query';
import { changePassword, type ChangePasswordParams } from '../../api';

export function useChangePassword() {
  return useMutation({
    mutationFn: (params: ChangePasswordParams) => changePassword(params),
  });
}
